import { render, staticRenderFns } from "./kt-renewed.vue?vue&type=template&id=613cb346&scoped=true&"
import script from "./kt-renewed.vue?vue&type=script&lang=js&"
export * from "./kt-renewed.vue?vue&type=script&lang=js&"
import style0 from "./kt-renewed.vue?vue&type=style&index=0&id=613cb346&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613cb346",
  null
  
)

export default component.exports